import React, {useState, useEffect, useRef} from "react";
import styled from "styled-components";
import {useDimensions, Box, Text} from "@chakra-ui/react";
import {useLocation} from 'react-router-dom';

const TallOuterContainer = styled.div.attrs(({dynamicHeight}) => ({
    style: {height: `${dynamicHeight}px`}
}))`
  position: relative;
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
`;

const StickyInnerContainer = styled.div`
  position: sticky;
  top: 0;
  /*
  height: 492px;
  @media screen and (min-width: 758px) {
    height: 700px;
  }
  */
  height: 100vh;
  width: 100%;
  max-width: 1500px;
  margin: 0 auto;
  overflow-x: hidden;
`;

const HorizontalTranslateContainer = styled.div.attrs(({translateX}) => ({
    style: {transform: `translateX(${translateX}px)`}
}))`
  position: absolute;
  height: calc(100% - 92px);
  will-change: transform;
`;

const calcDynamicHeight = (objectWidth, containerWidth) => {
    const vw = containerWidth;
    const vh = window.innerHeight;
    // console.log('calculating dynamic height', objectWidth, containerWidth, window.innerHeight, objectWidth - vw + vh + 50);
    return objectWidth - vw + vh + 50;
};

const handleDynamicHeight = (ref, setDynamicHeight, containerWidth) => {
    // console.log('ref.current', ref.current, ref.current.scrollWidth);
    const objectWidth = ref.current.scrollWidth;
    const dynamicHeight = calcDynamicHeight(objectWidth, containerWidth);
    setDynamicHeight(dynamicHeight);
};

const applyScrollListener = (ref, setTranslateX) => {
    window.addEventListener("scroll", () => {
        const offsetTop = ref.current ? -ref.current.offsetTop : 0;
        setTranslateX(offsetTop);
    });
};

export default ({data, children}) => {
    const [dynamicHeight, setDynamicHeight] = useState(null);
    const [translateX, setTranslateX] = useState(0);
    const location = useLocation();

    const containerRef = useRef(null);
    const objectRef = useRef(null);

    const dimen = useDimensions(containerRef, true);

    const resizeHandler = () => {
        handleDynamicHeight(objectRef, setDynamicHeight, dimen?.contentBox.width);
    };

    useEffect(() => {
        
        let time = setTimeout(function () {
            handleDynamicHeight(objectRef, setDynamicHeight, dimen?.contentBox.width);
        }, 250);
        window.addEventListener("resize", resizeHandler);
        applyScrollListener(containerRef, setTranslateX);
        return () => {
            clearTimeout(time);
            window.removeEventListener('resize', resizeHandler);
        }; 
    }, [dimen?.contentBox.width, children]);


    return (
        <TallOuterContainer dynamicHeight={dynamicHeight}>
            <StickyInnerContainer ref={containerRef}>
                <Text
                    pb={'40px'}
                    pt={'20px'}
                    as={'h1'}
                    lineHeight={'2rem'}
                    textAlign={'left'}
                    fontSize={'2rem'}
                >
                    Meet {data?.acf?.first_name}
                </Text>
                <HorizontalTranslateContainer translateX={translateX} ref={objectRef}>
                    {children}
                </HorizontalTranslateContainer>
            </StickyInnerContainer>
        </TallOuterContainer>
    );
};
